import React from 'react'
import { withStyles, Typography } from '@material-ui/core'
import PropTypes from 'prop-types'
import airglossIcons from './airglossIcons'
import clsx from 'clsx'

const styles = theme => ({
  root: {
    fontFamily: 'airgloss-font',
    fontSize: '18px',
    lineHeight: '1',
    fontWeight: '400'
  }
});

const gasIcons = {
  'co': <Typography>CO</Typography>,
  'co2': <Typography>CO<sub>2</sub></Typography>,
  'no2': <Typography>NO<sub>2</sub></Typography>,
  'ch4': <Typography>CH<sub>4</sub></Typography>,
};

const AgIcon = ({ className, component: Component, icon, size, classes, style, ...props }) => {
  if (icon in gasIcons) {
    return gasIcons[icon];
  }
  if (icon.charAt(0) <= 'z') icon = airglossIcons[icon];

  return <Component
    className={clsx(classes.root, className)}
    style={{ fontSize: size + 'px', ...style }}
    {...props}
  >
    {icon}
  </Component>
};

AgIcon.propTypes = {
  icon: PropTypes.string,
  size: PropTypes.number,
  classes: PropTypes.object,
  className: PropTypes.string
};

AgIcon.defaultProps = {
  component: 'span',
  icon: '',
  size: 20
};

export default withStyles(styles)(AgIcon)
